import React from 'react';
import { Box, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { translate } from 'translations/translator';
import ModalsTranslationVariant from 'translations/variants/modals';
const getTranslation = (key: ModalsTranslationVariant) => translate('modals', key);

export enum RESOURCE_TOGGLE_TYPE {
  HWT_RESOURCES = 'HWT_RESOURCES',
  MY_PORTFOLIO = 'MY_PORTFOLIO',
  PINNED_RESOURCES = 'PINNED_RESOURCES'
}

const DEFAULT_STYLES = { borderBottom: ' 4px solid #000000', color: '#000000' };

export const ActivityToggleNav = ({ toggledActivityType, handleChange }) => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <ToggleButtonGroup onChange={handleChange} classes={{ root: classes.container }}>
        <ToggleButton
          size="large"
          className={classes.toggleBtn}
          value={RESOURCE_TOGGLE_TYPE.HWT_RESOURCES}
          style={toggledActivityType === RESOURCE_TOGGLE_TYPE.HWT_RESOURCES ? DEFAULT_STYLES : {}}
        >
          {getTranslation(ModalsTranslationVariant.hwtResources)}
        </ToggleButton>
        <ToggleButton
          size="large"
          className={classes.toggleBtn}
          value={RESOURCE_TOGGLE_TYPE.PINNED_RESOURCES}
          style={
            toggledActivityType === RESOURCE_TOGGLE_TYPE.PINNED_RESOURCES ? DEFAULT_STYLES : {}
          }
        >
          {getTranslation(ModalsTranslationVariant.pinnedResources)}
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flex: 1,
    '& .Mui-selected': {
      color: '#0000008A !important',
      fontWeight: '500 !important'
    }
  },
  toggleBtn: {
    display: 'flex !important',
    flex: 1,
    textTransform: 'none !important',
    width: '100px',
    borderTop: 'none !important',
    borderLeft: 'none !important',
    borderRight: 'none !important',
    '&:hover': {
      backgroundColor: 'unset !important'
    },
    '&:disabled': {
      border: 'none'
    }
  } as any
}));
